import React from 'react';
import { animated, useSpring } from '@react-spring/web';
import { clsx, negative } from '@pushpay/styles';
import { memo } from '@pushpay/types';
import { itemPaddingH, useNavigationStyles } from './navigation-styles';
export const NavigationItemLabel = memo(function NavigationItemLabel({
  children,
  displayStyle,
  classes: classesProp,
  className: classNameProp
}) {
  const classes = useNavigationStyles(classesProp);
  const className = clsx(classes.label, classNameProp);
  const style = useSpring({
    opacity: displayStyle === 'collapsed' ? 0 : 1,
    translateX: displayStyle === 'collapsed' ? negative(itemPaddingH) : '0px'
  });
  return /*#__PURE__*/React.createElement(animated.span, {
    style: style,
    className: className
  }, children);
});